// src/App.js
import { Routes, Route, useLocation, Router } from "react-router-dom";
import { Suspense, useEffect, lazy, useState } from "react";
import Footer from "./Components/Footer";
import ScrollToTopButton from "./Components/ScrollButton";
import CookieConsent from "./Components/CookiesBanner";
import SocialSidebar from "./Components/socialmedia";
import Loader from "./Components/Loader";
import Resources from "./Pages/Resources";
import Blogs from "./Pages/Resources/Blogs/inde";
import Videos from "./Pages/Resources/Videos";
import Brouchers from "./Pages/Resources/Brochers.js";
import FAQ from "./Pages/FAQ/index.js";
import Events from "./Pages/Events/index.js";
// import Chatbot from "./Components/chatbot/index.js";
import PopUp from "./Components/pop-up/index.js";
import confetti from "canvas-confetti"; // 🎉 Confetti blast

import WebApplicationServise from "./Pages/Servicess/webdesign/index.js";
import DigitalMarketingService from "./Pages/Servicess/digitalMarket/index.js";

// Lazy load all page components
const Home = lazy(() => import("./Pages/Home"));
const ContactPage = lazy(() => import("./Pages/Contact"));
const AboutPage = lazy(() => import("./Pages/About"));
const ServicePage = lazy(() => import("./Pages/Servicess"));
const FreeTrailPage = lazy(() => import("./Pages/Freetrails"));

const NewBusiness = lazy(() => import("./Pages/Servicess/NewBusiness"));
const Reporting = lazy(() => import("./Pages/Servicess/Reporting"));
const PolicyManagement = lazy(() => import("./Pages/Servicess/PolicyManagement"));
const Accounting = lazy(() => import("./Pages/Servicess/Accounting"));
const CommissionManagement = lazy(() => import("./Pages/Servicess/CommisionManagement"));
const ClaimManagement = lazy(() => import("./Pages/Servicess/ClaimManagement/index"));
const ClaimData = lazy(() => import("./Pages/Servicess/ClaimData"));
const PrivacyPolacies = lazy(() => import("./Pages/Privacy_Policies/index.js"));
const TermsConditions = lazy(() => import("./Pages/Terms&conditions/index.js"));

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
};

function App() {
  const [showLoader, setShowLoader] = useState(true);
  const [showPopUp, setShowPopUp] = useState(false);
  const handleConfetti = () => {
    confetti({
      particleCount: 400, 
      spread: 160,      
      angle: 90,      
      origin: { y: 0.6 },
      colors: ["#ff0", "#0f0", "#00f", "#f0f", "#ff6600", "#00ffff"],
      shapes: ["square", "circle"],
      scalar: 1.4,
      gravity: 0.6,
      ticks: 300
    });
  };


  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 2200);
    return () => clearTimeout(timer);
  }, []);


  useEffect(() => {

    const alreadyShown = localStorage.getItem("popupShown");

    if (!alreadyShown) {
      setShowPopUp(true);
      localStorage.setItem("popupShown", "true");

      setTimeout(() => {
        handleConfetti()
      }, 600);
    }
  }, []);



  return (
    <>
      {/* Loader Screen */}
      {showLoader && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white">
          <Loader />
        </div>
      )}

      <ScrollToTop />

      <Suspense fallback={<div className="text-center py-10"></div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/free-trial" element={<FreeTrailPage />} />
          <Route path="/events" element={<Events />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/privacy-policy" element={<PrivacyPolacies />} />
          <Route path="/terms-and-conditions" element={<TermsConditions />} />

          <Route path="/services" element={<ServicePage />}>
            <Route path="new-business-services" element={<NewBusiness />} />
            <Route path="insurance-reporting-services" element={<Reporting />} />
            <Route path="policy-management-services" element={<PolicyManagement />} />
            <Route path="insurance-accounting-services" element={<Accounting />} />
            <Route path="commission-management-services" element={<CommissionManagement />} />
            <Route path="claims-management-services" element={<ClaimManagement />} />
            <Route path="claims-data-entry-services" element={<ClaimData />} />
            <Route path="web-application-services" element={<WebApplicationServise />} />
            <Route path="digital-marketing-services" element={<DigitalMarketingService />} />
          </Route>

          <Route path="/resources" element={<Resources />}>
            <Route path="blogs" element={<Blogs />} />
            <Route path="videos" element={<Videos />} />
            <Route path="brochures" element={<Brouchers />} />
          </Route>
        </Routes>

        {/* POPUP */}
        {showPopUp && (
          <div className="fixed inset-0 flex items-center justify-center z-[9998] ">
            <PopUp
              title={"FREE TRIAL"}
              descriptions={
                "Enjoy a 7-day free trial with full access to all premium features. " +
                "No credit card required. Explore our tools, test integrations, " +
                "and see how we can help you achieve your goals faster. " +
                "Cancel anytime during the trial no questions asked."
              }
              data={""}
              showToogle={true}
              showbuttons={true}
              onClose={() => setShowPopUp(false)}
            />
            <handleConfetti />
          </div>
        )}
        <SocialSidebar />
        {/* <Chatbot /> */}
        <ScrollToTopButton />
        <Footer />
        {/* <CookieConsent /> */}
      </Suspense>
    </>
  );
}

export default App;
